import { Outlet } from 'react-router-dom';
import { PageSuspense } from '@/shared/components';

/**
 * Chrome-less layout used by /sign-in. Matches PropertyScanUI SignIn.jsx —
 * centered on ink-50 background, no sidebar or topbar.
 */
export function AuthLayout() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-ink-50 p-4">
            <PageSuspense><Outlet /></PageSuspense>
        </div>
    );
}
